<template>
    <section :class="theme === 'dark' ? 'tw-bg-[#1a1d21]' : 'tw-bg-slate-50'" class="tw-rounded-xl tw-p-4">
        <div class="tw-grid tw-grid-cols-2 tw-gap-3 tw-mb-3">
            <div class="tw-justify-center tw-rounded-lg tw-p-2 tw-flex tw-items-center tw-gap-2">
                <img src="/images/icons/estacao/sol.png" alt="temperatura" id="imgTemp" style="width: 19px"/>
                <p :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-900'" class="tw-text-lg tw-font-bold">{{ estacao ? estacao.temperatura : '--' }}°C</p>
            </div>
            <div class="tw-justify-center tw-rounded-lg tw-p-2 tw-flex tw-items-center tw-gap-2">
                <img src="/images/icons/estacao/umidade.png" alt="umidade" id="imgUmidade" style="width: 19px"/>
                <p :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-900'" class="tw-text-lg tw-font-bold">{{ estacao ? estacao.umidade : '--' }}%</p>
            </div>
        </div>
        <div class="tw-justify-center tw-rounded-lg tw-p-2 tw-flex tw-items-center tw-gap-2 tw-mb-2">
            <img src="/images/icons/estacao/nuvem.png" alt="chuva" id="imgChuva" style="width: 19px"/>
            <p :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-900'" class="tw-text-md tw-font-bold">{{ estacao && estacao.chuva > 0 ? 'Chovendo' : 'Sem chuva' }}</p>
        </div>
        <div :class="theme === 'dark' ? 'tw-border-slate-600' : 'tw-border-slate-200'" class="tw-border-t tw-pt-3 tw-mt-3">
            <p :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-600'" class="tw-text-xs tw-text-center">Estação {{ estacao ? estacao.estacao : '--' }}</p>
            <p :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-500'" class="tw-text-xs tw-text-center">{{ estacao ? dataFormatada(estacao.data) : '--' }}</p>
        </div>
    </section>
</template>
<script>
import { computed } from 'vue';
import { useStore } from 'vuex';

export default {
    name: "EstacaoComponent",
    props: {
        estacao: {
            type: Object,
            required: true,
            default: () => ({}),
        },
    },

    setup() {
        const store = useStore();
        const theme = computed(() => store.state.ui.theme);

        const dataFormatada = (data) => {
            const date = new Date(data);
            const day = String(date.getDate()).padStart(2, "0");
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const year = date.getFullYear();
            const hours = String(date.getHours()).padStart(2, "0");
            const minutes = String(date.getMinutes()).padStart(2, "0");
            const seconds = String(date.getSeconds()).padStart(2, "0");
            return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
        };

        return {
            theme,
            dataFormatada
        }
    }
};
</script>